import Page from "@/components/pages/inventory/sales-order/overview/page";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";

const searchSchema = z.object({
	salesOrderId: z.string().optional(),
	type: z.enum(["edit", "view", "add"]).optional(),
	status: z
		.enum([
			"ALL",
			"DRAFT",
			"AWAITING_PAYMENT",
			"PROCESSING",
			"COMPLETED",
			"CANCELLED",
		])
		.catch("PROCESSING")
		.default("PROCESSING"),
	needRefresh: z.boolean().optional(),
});

export const Route = createFileRoute("/_app/inventory/sales-order/_modal/")({
	component: Page,
	validateSearch: zodValidator(searchSchema),
});
